import React from "react";
import { Navbar } from "./Layout/Navbar";


const Layout = ({ children }) => {
    return (
        // <div
        //     style={{
        //         minHeight: "100vh",
        //         backgroundImage: `url(${process.env.PUBLIC_URL}/img/wooden_bg.png)`,
        //         backgroundSize: "cover",
        //         backgroundPosition: "center",
        //         backgroundRepeat: "no-repeat",
        //         backgroundAttachment: "fixed",
        //     }}
        // >
          <div style={{ minHeight: "100vh" }}>
            <Navbar />
            <main>
                {children}
            </main>
        </div>
    );
};

export default Layout;
